import Legabilidade from "../../../../assets/images/ilustra-documento.svg";
import Celular from "../../../../assets/images/ilustra-celular.svg";

import { FilePicker } from "../../../../components/filepicker";
import { Icon } from "../../../../components/icon";
import Arrow from "../../../../assets/icons/arrow-right.svg";
import { useState, useEffect } from "react";
import { documentValidator, requiredValidator } from "../../../../utils/validators";
import { FormSelect } from "../../components/form-select";
import { Switch } from "../../../../components/switch";

import { AbrirContaLoading } from "../abrir-conta-loading";

export const Documentacao = ({ nextStep, prevStep }) => {
    const [formData, setFormData] = useState({ 
        contratoSocial: false, 

        rgFrente:false,
        rgVerso:false,

        contratoSocialJuridico:true,
        comprovanteEndereco:false,



        admRgFrente:true,
        admRgVerso:true,

        admContratoSocial:true,



        advRgFrente:true,
        advRgVerso:true

    });
    const [isValid, setIsValid] = useState(false);

    const [hasAdm, setHasAdm] = useState(true);
    const [hasAdv, setHasAdv] = useState(false);

    const [phoneNotify, setPhoneNotify] = useState(false);
    const [agreeTerms, setAgreeTerms] = useState(false);

    const updateField = (field, state) => {
        if(field.slice(0,3) === "adm" && !hasAdm) state = true
        if(field.slice(0,3) === "adv" && !hasAdv) state = true

        setFormData(oldState => {
            const ccpy = { ...oldState }
            ccpy[field] = state;
            return { ...ccpy }

        })


    }

    useEffect(() => {
        setIsValid(true);
        for (const v of Object.values(formData)) {
            if (v == false) {
                setIsValid(false);
                break;
            }
        }
    }, [formData])

    const [loadingSend, setLoadingSend] = useState(false)

    const [apiError, setApiError] = useState("")
    const onSubmit = (e) => {
        e.preventDefault();
        if (isValid) {
            const contratoSocial = e.target.contratoSocial.files[0]

            const tp_doc = e.target.tpDoc.value
            const docRepresentanteFrente = e.target.rgFrente.files[0]
            const docRepresentanteVerso = e.target.rgVerso.files[0]

            const contratoSocialJuridico = e.target.contratoSocialJuridico.files[0]

            const comprovanteEndereco = e.target.comprovanteEndereco.files[0]

            let docSocioFrente = null
            let docSocioVerso = null

            let contratoSocialAdm = null

            let tp_docSocio = null
            if(hasAdm) {
                docSocioFrente = e.target.admRgFrente.files[0]
                docSocioVerso = e.target.admRgVerso.files[0]
                contratoSocialAdm = e.target.admContratoSocial.files[0]
                tp_docSocio = e.target.docAdm.value
            }
            else if(hasAdv) {
                docSocioFrente = e.target.advRgFrente.files[0]
                docSocioVerso = e.target.advRgVerso.files[0]
                tp_docSocio = e.target.docAdv.value
            }
            

            let d = new FormData()
            d.append('dc_contrato_social',contratoSocial)

            d.append('dc_id_representante',docRepresentanteFrente)
            d.append('dc_id_representante_verso',docRepresentanteVerso)

            d.append('tp_dc_representante',tp_doc)

            d.append('dc_contrato_social_juridico',contratoSocialJuridico)
            d.append('dc_comprovante_endereco',comprovanteEndereco)

            d.append('tp_socio', hasAdv? 0 : 1)

            d.append('dc_id_socio',docSocioFrente)
            d.append('dc_id_socio_verso',docSocioVerso)

            d.append('tp_dc_id_socio',tp_docSocio)

            d.append('dc_contrato_social_adm',contratoSocialAdm)

            d.append('id_empresa', localStorage.getItem("idEmpresa"))

            setLoadingSend(true)
            fetch(process.env.REACT_APP_API_URL+'Register_CompanyDocument',
                {
                    headers: {
                    },
                    method: "POST",
                    body: d,
                })
                .then((response)=>{ 
                    response.json().then((json)=>{
                        if(json.hasError===false) {
                            nextStep();
                        
                        }else{
                            setApiError(json.description)
                            setTimeout(() => {setApiError("")}, 1500)
                        }
                        }).finally(setLoadingSend(false))
            })
            
        }
    };

    const toggleAdm = () => {
        const newVal = !hasAdm
        const fields = Object.keys(formData).filter((v) => v.slice(0,3) === "adm")
        
        if(newVal === false){
            fields.forEach((f) => {
                updateField(f, true)
            })
        }
        setHasAdm(newVal)
        setHasAdv(!newVal)
    }

    const toggleAdv = () => {
        const newVal = !hasAdv
        const fields = Object.keys(formData).filter((v) => v.slice(0,3) === "adv")
        
        if(newVal === false){
            fields.forEach((f) => {
                updateField(f, true)
            })
        }
        setHasAdv(newVal)
        setHasAdm(!newVal)
    }

    if(loadingSend) return <AbrirContaLoading/>
    else
    return (
       
        <form className='conta-content' onSubmit={onSubmit}>
            <div className='conta-content-section'>
                <h2 className="conta-section-title">Documentação</h2>
                <p className="conta-section-subtitle" style={{ fontWeight: 'bold' }}>Precisamos de alguns documentos para abrir sua conta.</p>
                <p className="conta-section-subtitle">Caso você não consiga enviar algum desses documentos agora, poderá enviá-los após concluir esse cadastro.<br />Nossa equipe entrará em contato.</p>
                <p className="conta-section-subtitle">Temos algumas dicas para agilizar sua aprovação.</p>

                <div className="row" style={{ gap: 10, flexWrap: "wrap" }}>
                    <div className="tip-container">
                        <div className="icon" style={{ marginTop: -25 }}>
                            <img alt="Legibilidade" src={Legabilidade} />
                        </div>
                        <div className="body">
                            <span className="title"> Legibilidade </span>
                            <div className="text-container">
                                <div></div>
                                <span className="text"> Retire o documento do plástico e abra-o para que a frente e o verso fiquem legíveis.</span>
                                <span className="text"> Verifique se o seu dedo não está cobrindo alguma informação do documento. </span>
                            </div>
                        </div>
                    </div>
                    <div className="tip-container">
                        <div className="icon" style={{ marginTop: -10 }}>
                            <img alt="Brilho" src={Celular} />
                        </div>
                        <div className="body">
                            <span className="title"> Brilho e nitidez </span>
                            <div className="text-container">
                                <div></div>
                                <span className="text"> Tire a foto em um ambiente claro. </span>
                                <span className="text"> Tenha cuidado com o flash da câmera, pois pode causar reflexos no documento. </span>
                            </div>
                        </div>
                    </div>
                </div>

                <p className="conta-section-subtitle" style={{ fontWeight: 'bold' }}>Empresa e Sócios</p>
                <div className="column">
                    <div className="file-row">
                        <div className="title">Contrato social</div>
                        <div className="desc">O Faturamento, DRE, Balanço Patrimonial e Balanço Patrimonial deverão ser assinados pelo sócio e pelo contador</div>
                        <div className="input"><FilePicker id="contratoSocial" validators={[{func:requiredValidator},{ func: documentValidator}]} updateField={updateField}/></div>
                    </div>
                    <div className="file-row">
                        <div className="title">Documento de identificação (Representante legal)</div>
                        <div className="desc">
                            <FormSelect id="tpDoc" defaultValue="1" label="Escolha o tipo de documento">
                                <option value="1">RG</option>
                                <option value="2">CPF</option>
                                <option value="3">CNH</option>
                            </FormSelect>
                        </div>
                        <div className="input">
                            <FilePicker text="Frente" id="rgFrente" validators={[{func:requiredValidator},{ func: documentValidator}]} updateField={updateField}/>
                            <FilePicker text="Verso" id="rgVerso" validators={[{func:requiredValidator},{ func: documentValidator}]} updateField={updateField}/>
                        </div>
                    </div>
                    <div className="file-row">
                        <div className="title">Contrato social (Sócio Pessoa Jurídica)</div>
                        <div className="desc">
                            Somente se um dos sócios for pessoa jurídica
                        </div>
                        <div className="input">
                            <FilePicker id="contratoSocialJuridico" validators={[{ func: documentValidator}]} updateField={updateField}/>
                        </div>
                    </div>
                    <div className="file-row">
                        <div className="title">Comprovante de endereço da empresa</div>
                        <div className="desc">
                            Contas de consumo como água, luz, telefone, internet com no máximo 90 dias
                        </div>
                        <div className="input">
                            <FilePicker id="comprovanteEndereco" validators={[{func:requiredValidator},{ func: documentValidator}]} updateField={updateField}/>
                        </div>
                    </div>
                    <div className="row" style={{alignItems:"center", gap:10}}><Switch value={hasAdm} 
                        onChange={toggleAdm}
                    /><p className="conta-section-subtitle" style={{ fontWeight: 'bold' }}>Administradores</p></div>
                    
                    {hasAdm && <div>
                        <div className="file-row">
                            <div className="title">Documento de identificação (Administrador)</div>
                            <div className="desc">
                                <FormSelect id="docAdm" defaultValue="1" label="Escolha o tipo de documento">
                                    <option value="1">RG</option>
                                    <option value="2">CPF</option>
                                    <option value="3">CNH</option>
                                </FormSelect>
                            </div>
                            <div className="input">
                                <FilePicker text="Frente" id="admRgFrente" validators={[{func:requiredValidator},{ func: documentValidator}]} updateField={updateField}/>
                                <FilePicker text="Verso" id="admRgVerso" validators={[{func:requiredValidator},{ func: documentValidator}]} updateField={updateField}/>
                            </div>
                        </div>
                        <div className="file-row">
                            <div className="title">Contrato social (Administrador)</div>
                            <div className="desc">
                            O Faturamento, DRE, Balanço Patrimonial e Balanço Patrimonial deverão ser assinados pelo sócio e pelo contador
                            </div>
                            <div className="input">
                                <FilePicker id="admContratoSocial" validators={[{func:requiredValidator},{ func: documentValidator}]} updateField={updateField}/>
                            </div>
                        </div>
                    </div>}
                    
                    <div className="row" style={{alignItems:"center", gap:10}}><Switch value={hasAdv} onChange={toggleAdv}/><p className="conta-section-subtitle" style={{ fontWeight: 'bold' }}>Advogados</p></div>
                    
                    {hasAdv && 
                        <div className="file-row">
                            <div className="title">Documento de identificação (Advogado responsável)</div>
                            <div className="desc">
                                <FormSelect id="docAdv" defaultValue="1" label="Escolha o tipo de documento">
                                    <option value="1">RG</option>
                                    <option value="2">CPF</option>
                                    <option value="3">CNH</option>
                                </FormSelect>
                            </div>
                            <div className="input">
                                <FilePicker text="Frente" id="advRgFrente" validators={[{func:requiredValidator},{ func: documentValidator}]} updateField={updateField}/>
                                <FilePicker text="Verso" id="advRgVerso" validators={[{func:requiredValidator},{ func: documentValidator}]} updateField={updateField}/>
                            </div>
                        </div>
                    }
                    <div className="row" style={{alignItems:"center", gap:10}}><input type="checkbox" onChange={(e)=>{setPhoneNotify(e.target.checked)}} onClick={(e)=>{setPhoneNotify(e.target.checked)}}/><p className="conta-section-subtitle" style={{ fontWeight: 'bold' }}>Concordo em receber informações importantes sobre minha conta via celular</p></div>
                    <div className="row" style={{alignItems:"center", gap:10}}><input type="checkbox" onChange={(e)=>{setAgreeTerms(e.target.checked)}} onClick={(e)=>{setAgreeTerms(e.target.checked)}}/><p className="conta-section-subtitle" style={{ fontWeight: 'bold' }}>Concordo com os <a className="inlink">termos de uso e política de privacidade</a></p></div>
                    
                </div>
                
            </div>

            <div className='conta-content-footer'>
                <button type="button" className='step-button prev-step' onClick={prevStep}>
                    <span className='icon'> <Icon icon={Arrow} size={18} rotation={180} /> </span>
                    <span className="text">Voltar</span>
                </button>
                <div className='divider'></div>
                <button type="submit" disabled={(!isValid || !agreeTerms)} className='step-button next-step'>
                    <span className="text">Prosseguir</span>
                    <span className='icon'> <Icon icon={Arrow} size={18} /> </span>
                </button>
            </div>
            {apiError !== "" && <div style={{width:"100%", display:"flex", justifyContent:"end", marginTop:"10px"}}> 
                <span style={{color:"red"}}> {apiError} </span>
            </div>}
        </form>
    );
};